import {Outlet} from 'react-router';
import {FirebaseApp} from '../firebase/FirebaseApp';
import {ComponentWithoutChildren} from '../react/types';

export const FirebaseOutlet: ComponentWithoutChildren = () => {
  return (
    <FirebaseApp>
      <Outlet />
    </FirebaseApp>
  );
};

export default FirebaseOutlet; // Default export required for react lazy
